export default __webpack_public_path__ + "static/media/16.09f23508.jpeg";